import React from 'react'
import SideNavbar from '../component/dashboard/SideNavbar'
import { Outlet } from 'react-router-dom';

function AdminDashBoard() {
  return (
  <div className="admin-dashboard-main-content">
      <div className="sidebar">
        <SideNavbar />
      </div>
      <div className="dashboard-main-content">
      <Outlet />
      </div>
    </div>
  )
}

export default AdminDashBoard